import {
  AppStoreBadges,
  StyledCard,
  StyledPhoneImage,
} from '@/src/components/Banners/GetBeyondBanner/GetBeyondBanner.styles';
import { P, theme } from '@ovotech/element-v5';
import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@/src/utils/mediaQuery';

export interface BeyondBannerProps {
  heading: {
    startText: string;
    highlightedText?: string;
  };
  description: string[];
  smallImageSrc: string;
  largeImageSrc: string;
  onAppStoreButtonClick?: () => void;
  onGooglePlayButtonClick?: () => void;
}

const Heading = styled.h2`
  color: ${theme.color.surface.onSurface};
  font-size: ${theme.font.size['3xl'].mediaQuery.lg};
  line-height: ${theme.font.lineHeight['3xl'].mediaQuery.lg};
  letter-spacing: ${theme.font.letterSpacing['3xl'].mediaQuery.lg};
  font-weight: ${theme.font.weight.black};

  @media ${breakpoints.mediumUp} {
    margin-bottom: ${theme.space['600']};
  }

  @media ${breakpoints.mediumDown} {
    font-size: ${theme.font.size['2xl'].mediaQuery.lg};
    line-height: ${theme.font.lineHeight['2xl'].mediaQuery.lg};
    letter-spacing: ${theme.font.letterSpacing['2xl'].mediaQuery.lg};
  }
`;

const Highlight = styled.span`
  color: ${theme.color.brand.brand};
`;

const BannerBottom = styled.div`
  display: flex;
  flex-direction: row;
`;

const BannerImage = styled.picture`
  flex: 0;
  align-items: flex-end;
`;

type ContentWrapperProps = {
  hasMargin?: boolean;
};

const ContentWrapper = styled.div<ContentWrapperProps>`
  width: 60%;

  @media ${breakpoints.mediumDown} {
    width: 100%;
    margin-bottom: ${({ hasMargin }: ContentWrapperProps) =>
      hasMargin ? '100px' : 0};
  }
`;

const TextContent = styled(P)`
  @media ${breakpoints.mediumDown} {
    span {
      display: block;
      margin-top: 30px;
      margin-bottom: 30px;
      width: 45%;
    }
  }
`;

export const BeyondBannerWhite = ({
  heading,
  description,
  smallImageSrc,
  largeImageSrc,
  onAppStoreButtonClick,
  onGooglePlayButtonClick,
}: BeyondBannerProps) => (
  <StyledCard variant="white">
    <Heading>
      {heading.startText}
      {heading.highlightedText && (
        <Highlight>{heading.highlightedText}</Highlight>
      )}
    </Heading>
    <ContentWrapper hasMargin={description.length < 2}>
      <TextContent>
        {description[0]}
        {description.length === 2 && <span>{description[1]}</span>}
      </TextContent>
    </ContentWrapper>
    <BannerBottom>
      <AppStoreBadges
        onAppStoreClick={onAppStoreButtonClick}
        onGooglePlayClick={onGooglePlayButtonClick}
      />
      <BannerImage>
        <source media={breakpoints.mediumUp} srcSet={largeImageSrc} />
        <StyledPhoneImage src={smallImageSrc} aria-hidden />
      </BannerImage>
    </BannerBottom>
  </StyledCard>
);
